import React from 'react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';
import { FileUpload } from '../FileUpload';
import { StepHeader } from '../StepHeader';
import { getStepStatus, toggleStep } from '../../utils/rankAListHelpers';

interface FileUploadStepProps {
  step: number;
  expandedSteps: number[];
  setExpandedSteps: (steps: number[]) => void;
  onFileUpload: (file: File) => void;
  uploadedFile?: File;
  columns?: any[];
  totalRows?: number;
}

export const FileUploadStep: React.FC<FileUploadStepProps> = ({
  step,
  expandedSteps,
  setExpandedSteps,
  onFileUpload,
  uploadedFile,
  columns,
  totalRows
}) => {
  const isOpen = expandedSteps.includes(1);
  
  const getTitle = () => {
    if (step > 1 && uploadedFile && columns && totalRows) {
      return (
        <span>
          Upload CSV File: <span className="text-slate-400">{uploadedFile.name} {columns.length} x {totalRows}</span>
        </span>
      );
    }
    return 'Upload CSV File';
  };
  
  return (
    <Collapsible 
      open={isOpen} 
      className="border border-slate-600 rounded-lg bg-slate-800"
    >
      <CollapsibleTrigger asChild>
        <button className="w-full" onClick={() => toggleStep(1, expandedSteps, setExpandedSteps)}>
          <StepHeader 
            stepNumber={1} 
            title={getTitle()} 
            status={getStepStatus(step, 1)}
            isOpen={isOpen}
          />
        </button>
      </CollapsibleTrigger>
      <CollapsibleContent className="px-4 pb-4">
        <FileUpload onFileUpload={onFileUpload} disabled={step > 1} />
      </CollapsibleContent>
    </Collapsible>
  );
}; 